module.exports = __webpack_public_path__ + "img/nowruz-1403-banner.76ac252.png";